/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from 'react';
import * as CustomWidgets from '.';
import * as API from '../../http/api';
import { useHistory } from 'react-router-dom';
import { makeStyles, createStyles } from '@mui/styles';
import { Button, ButtonGroup, FormControl, IconButton, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Theme, Tooltip, Typography, useTheme } from '@mui/material';
import { Build, Delete, Edit, EditAttributes, Menu, Settings, RemoveRedEye } from '@mui/icons-material';
import { openlightbox } from '../../util/Functions';
import moment from "moment";
import "moment/locale/es";
import ConfigFactor from '../modals/ConfigFactor';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        titlesTabs: {
            textRendering: "geometricPrecision",
            WebkitFontSmoothing: "antialiased !important",
            scrollBehavior: "smooth",
            fontFamily: "Muli,sans-serif !important",
            color: "#969BA0 !important",
            //fontWeight: 'bold'
        },
        contentTab: {
            padding: "10px !important",
        },
        firstTitle: {
            padding: "16px",
        },
        titleTable: {
            display: "flex",
            width: "100%",
        },
        buttonAdd: {
            marginLeft: "88% !important",
        },
        titleH2: {
            display: "flex",
        },
        iconTitle: {
            marginTop: "4px",
            marginRight: "5px",
        },
        textField: {
            marginLeft: theme.spacing(1),
            display: "flex !important",
            width: "25% !important",
            margin: "auto !important",
            marginRight: "0 !important",
        },
    })
);

const FactorList = (props) => {
    moment.locale("es");
    const classes = useStyles();
    const [list, setList] = useState([]);
    const [status, setStatus] = useState('');
    const theme = useTheme();
    const statusList = [
        {
            value: 'enabled',
            label: 'Activo',
        },
        {
            value: 'disabled',
            label: 'Inactivo',
        }
    ]
    const history = useHistory();

    useEffect(() => {
        init();
    }, [props.content]);

    const init = () => {
        if(props.content){
            if(props.content.factors){
                setList(JSON.parse(JSON.stringify(props.content.factors)));
            }
            if(props.content.hasOwnProperty('status')){
                setStatus(props.content.status);
            }
        }
    }

    const statusParse = (status) => {
        let parse = '';
        for(let i = 0; i<statusList.length; i++){
            if(status == statusList[i]['value']){
                parse = statusList[i]['label'];
                break;
            }
        }

        return parse;
    }

    const reloadData = async (data) => {
        props.changeLoader(true);
        let request = await API.service('adminFactors', data, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200 && request.data.data.response == 'OK') {
            props.changeWidgets(JSON.parse(JSON.stringify(request.data.data.widget)));
        }
    
        props.changeLoader(false);
    };

    const changeValue = async (e) => {
        let data = {
            status: e.target.value
        }

        await reloadData(data);
    }

    const openConfig = (type, data) => {
        let title = 'N/A';
        if(type == 'national'){
            title = 'Nacional'
        }

        if(type == 'international'){
            title = 'Internacional'
        }
        const as = <ConfigFactor
            root={type}
            config={data}
            title={title}
        />
        openlightbox(as);
    }

    const deleteFactor = async (uuid) => {
        props.changeLoader(true);
        let data = {
            uuid: uuid
        }
        let request = await API.service('deleteFactor', data, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200 && request.data.data.response == 'OK') {
            props.changeAlert(true, "success", 'El factor se elimino correctamente');
            await reloadData({status: status});
            //props.changeWidgets(JSON.parse(JSON.stringify(request.data.data.widget)));
        }
    
        props.changeLoader(false);
    }

    return <Paper sx={{width: '100%', padding: 2}}>
        <Typography
            component="div"
            children={
                <div className={classes.titleTable}>
                    <h2 className={classes.titleH2}>
                        <Settings className={classes.iconTitle}/>
                        <span>Factores de autorización</span>
                    </h2>
                </div>
            }
            fontWeight="bold"
            fontFamily="Muli,sans-serif"
            fontSize="20px"
        />
        <TableContainer className={classes.contentTab} sx={{maxHeight: 700}}>
            <FormControl sx={{minWidth: '25%', marginLeft: theme.spacing(1), display: "flex !important", width: "25% !important", margin: "auto !important", marginRight: "0 !important"}}>
                <InputLabel id="select-status" color='secondary'>Estatus</InputLabel>
                <Select labelId='select-status' value={status} label="Estatus" color='secondary' onChange={changeValue.bind(this)}>
                    <MenuItem value={''} color="secondary">Estatus</MenuItem>
                    {
                        statusList.map((item, index) => {
                            return <MenuItem value={item.value} key={`status-${index}`}>{item.label}</MenuItem>
                        })
                    }
                </Select>
            </FormControl>
            <Table arial-label="stick table">
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <Typography fontWeight="bold" fontFamily="Muli,sans-serif" color="#969BA0" fontSize="0.875rem">
                                Tipo
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography fontWeight="bold" fontFamily="Muli,sans-serif" color="#969BA0" fontSize="0.875rem">
                                UUID
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography fontWeight="bold" fontFamily="Muli,sans-serif" color="#969BA0" fontSize="0.875rem">
                                Estatus
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography fontWeight="bold" fontFamily="Muli,sans-serif" color="#969BA0" fontSize="0.875rem">
                                Fecha de creación
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography fontWeight="bold" fontFamily="Muli,sans-serif" color="#969BA0" fontSize="0.875rem">
                                Nacional
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography fontWeight="bold" fontFamily="Muli,sans-serif" color="#969BA0" fontSize="0.875rem">
                                Internacional
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography fontWeight="bold" fontFamily="Muli,sans-serif" color="#969BA0" fontSize="0.875rem">
                                Acciones
                            </Typography>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        list.map((item, index) => {
                            return <TableRow hover key={`row-role-${index}`}>
                                <TableCell>
                                    <Typography fontWeight="400" fontFamily="Muli,sans-serif" color="#000000de" fontSize="0.875rem">
                                        {item.type}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography fontWeight="400" fontFamily="Muli,sans-serif" color="#000000de" fontSize="0.875rem">
                                        {item.uuid}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography fontWeight="400" fontFamily="Muli,sans-serif" color="#000000de" fontSize="0.875rem">
                                        {statusParse(item.status)}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography fontWeight="400" fontFamily="Muli,sans-serif" color="#000000de" fontSize="0.875rem">
                                        {moment(new Date(item.cdate)).format('LLL')}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography fontWeight="400" fontFamily="Muli,sans-serif" color="#000000de" fontSize="0.875rem">
                                        {
                                            item.hasOwnProperty('national') ? 
                                            <Tooltip title="Ver configuracón">
                                                <IconButton onClick={openConfig.bind(this, 'national', item.national)}>
                                                    <RemoveRedEye/>
                                                </IconButton>
                                            </Tooltip> : 'N/A'
                                        }
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography fontWeight="400" fontFamily="Muli,sans-serif" color="#000000de" fontSize="0.875rem">
                                        {
                                            item.hasOwnProperty('international') ? 
                                            <Tooltip title="Ver configuracón">
                                                <IconButton onClick={openConfig.bind(this, 'international', item.international)}>
                                                    <RemoveRedEye/>
                                                </IconButton>
                                            </Tooltip> : 'N/A'
                                        }
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography fontWeight="400" fontFamily="Muli,sans-serif" color="#000000de" fontSize="0.875rem">
                                        <Tooltip title="Eliminar">
                                            <IconButton disabled={item.status != 'enabled' ? false : true} onClick={deleteFactor.bind(this, item.uuid)}>
                                                <Delete/>
                                            </IconButton>
                                        </Tooltip>
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        })
                    }
                </TableBody>
            </Table>
        </TableContainer>
    </Paper>
}

export default FactorList;